import { TableFilled } from '@components/Table';
import {
  FieldHeaderWrap,
  Label,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
  padding: 24px;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;
`;

export const Counter = styled.div`
  display: flex;
  height: 22px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 0px 6px;

  font-size: 14px;
  font-weight: 600;
  color: #474d66;

  margin-left: 8px;
`;

export const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const WrapperHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  column-gap: 4px;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const Buttons = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr 2fr 0.5fr;
  grid-row-gap: 0;
  grid-column-gap: 24px;

  padding-left: 12px;
`;

export const TablePrioritizedHeader = styled.div`
  display: grid;
  position: sticky;
  top: 0;
  background-color: #fff;
  grid-template-columns: 70px 4fr 1fr 85px;
  grid-row-gap: 0;
  grid-column-gap: 24px;

  margin-bottom: 8px;
  padding: 0 12px;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #8f95b2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;

  &.menu {
    color: transparent;
  }

  &.assetCount {
    color: #1371fe;
    font-size: 14px;
    font-weight: 500;
  }

  &.rowText {
    font-size: 14px;
    font-weight: 400;
    color: #1b203a;
  }
`;

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: grid;
  height: 50px;
  align-items: center;
  grid-template-columns: 1fr 30px;
  grid-row-gap: 0;
  grid-column-gap: 24px;
  cursor: pointer;

  background-color: #f5f7fb;
  border-radius: 8px;
  padding-left: 12px;
`;

export const RowInner = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 4fr 1fr 2fr;
  grid-row-gap: 0;
  grid-column-gap: 24px;
`;

export const RowPrioritized = styled.div`
  position: relative;
  display: grid;
  height: 50px;
  align-items: center;
  grid-template-columns: 1fr;
  grid-row-gap: 0;
  grid-column-gap: 24px;
  cursor: pointer;

  background-color: #f5f7fb;
  border-radius: 8px;
  padding: 0 12px 0 12px;
`;

export const RowInnerPrioritized = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 70px 4fr 1fr 85px;
  grid-row-gap: 0;
  grid-column-gap: 24px;
`;

export const HighlighterButton = styled.a`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
`;

export const NoUpdatesText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
`;

export const StrongGrey = styled.strong`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
`;

export const NoUpdatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const UpdatesTableAsset = styled(TableFilled)`
  && {
    --row-height: 50px;
    --row-bg-hover: var(--beam-color-neutral-n100);
    --heading-background: #fff;
    --row-block-padding: 0;

    [data-device='${deviceTypes.mobile}'] & {
      /* --row-height: 34px; */
      min-width: 625px;
      --row-height: 46px;
    }

    th[data-fieldname='Status'] {
      width: 68px;
    }
    th[data-fieldname='Date'] {
      width: 109px;
    }
    th {
      width: 100%;
    }
    th[data-fieldname='Subject'] {
      width: 225%;
    }
    table tbody tr td > .Table_content {
      cursor: pointer;
    }
  }
  ${Label} {
    height: 100%;
  }

  ${FieldHeaderWrap} {
    padding-right: 2px;
  }
`;

export const Strong = styled.strong`
  color: #ff9900;
  font-size: 14px;
  font-weight: 400;
`;

export const Assignee = styled.img`
  height: 24px;
  width: 24px;
  object-fit: cover;
  border-radius: 12px;
`;

export const Span1 = styled.span`
  margin-left: 7.1px;
  padding: 5px;
`;

export const Span2 = styled.span`
  margin-left: 3px;
  padding: 5px;
`;

export const Empty = styled.div`
  color: #8f95b2;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
`;

export const IconContainer = styled.div`
  height: 20px;
`;

export const Add = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 6px;
  margin-left: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const HelpToolTipTextDiv = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
`;

export const LoadingLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 8px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Test = styled.div``;

export const HeaderText = styled.div`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  font-size: 12px;
  font-weight: 400;
  color: #8f95b2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const SortingIconContainer = styled.div`
  margin-top: -4px;
`;
